// extracted by mini-css-extract-plugin
export default {"wrap":"useDemoMode_wrap__TLFBo","demoModeFlow":"useDemoMode_demoModeFlow__G0nNY","demoModePage":"useDemoMode_demoModePage__V2vLt","pageModeBox":"useDemoMode_pageModeBox__5EeRL"};